module.exports = __webpack_public_path__ + "img/invoices_done.d274c91c.png";